<template>
  <div class="nw-center">
    <!-- 储能-->
    <span v-for="(item,index) in centerImgs" :key="index" class="type1-wrap"
      v-if="item.class=='type1' && centerImgId==item.panelId">
      <img :class="item.class" :src="item.src" />
      <span class="threeParts">
        <!-- 储能 -->
        <span v-if="realData.storedenergypower" class="cn">
          <img src="/static/images/svolt/nanwang/chongdianzhuang-bj.png" />
          <span class="number">{{ realData.storedenergypower.value }}</span>
          <div class="txt">
            <span v-if="realData.storedenergypower.status != ''" class="status"
              :style="{ background: realData.storedenergypower.status }"></span>
            <span class="desc">{{ realData.storedenergypower.desc }}（{{ realData.storedenergypower.unit }}）</span>
          </div>
        </span>
        <!-- 电网 -->
        <span v-if="realData.electricsupplypower" class="dw">
          <img src="/static/images/svolt/nanwang/chongdianzhuang-bj.png" />
          <span class="number">{{ realData.electricsupplypower.value }}</span>
          <div class="txt">
            <span v-if="realData.electricsupplypower.status != ''" class="status"
              :style="{ background: realData.electricsupplypower.status }"></span>
            <span class="desc">{{ realData.electricsupplypower.desc }}（{{ realData.electricsupplypower.unit }}）</span>
          </div>
        </span>
        <!-- 负荷 -->
        <span v-if="realData.loadpower" class="fh">
          <img src="/static/images/svolt/nanwang/chongdianzhuang-bj.png" />
          <span class="number">{{ realData.loadpower.value }}</span>
          <div class="txt">
            <span v-if="realData.loadpower.status != ''" class="status"
              :style="{ background: realData.loadpower.status }"></span>
            <span class="desc">{{ realData.loadpower.desc }}（{{ realData.loadpower.unit }}）</span>
          </div>
        </span>
        <!-- <div class="flow">
          <FlowBall :styles="dir01" :dir="1"></FlowBall>
          <FlowBall :styles="dir02" :dir="2"></FlowBall>
          <FlowBall :styles="dir03" :dir="3"></FlowBall>
        </div> -->
      </span>
    </span>
    <!-- 光储-->
    <span v-for="(item,index) in centerImgs" :key="index" class="type2-wrap"
      v-if="item.class=='type2' && centerImgId==item.panelId">
      <img :class="item.class" :src="item.src" />
      <span class="threeParts">
        <!-- 储能 -->
        <span v-if="realData.storedenergypower" class="cn">
          <img src="/static/images/svolt/nanwang/chongdianzhuang-bj.png" />
          <span class="number">{{ realData.storedenergypower.value }}</span>
          <div class="txt">
            <span v-if="realData.storedenergypower.status != ''" class="status"
              :style="{ background: realData.storedenergypower.status }"></span>
            <span class="desc">{{ realData.storedenergypower.desc }}（{{ realData.storedenergypower.unit }}）</span>
          </div>
        </span>
        <!-- 电网 -->
        <span v-if="realData.electricsupplypower" class="dw">
          <img src="/static/images/svolt/nanwang/chongdianzhuang-bj.png" />
          <span class="number">{{ realData.electricsupplypower.value }}</span>
          <div class="txt">
            <span v-if="realData.electricsupplypower.status != ''" class="status"
              :style="{ background: realData.electricsupplypower.status }"></span>
            <span class="desc">{{ realData.electricsupplypower.desc }}（{{ realData.electricsupplypower.unit }}）</span>
          </div>
        </span>
        <!-- 负荷 -->
        <span v-if="realData.loadpower" class="fh">
          <img src="/static/images/svolt/nanwang/chongdianzhuang-bj.png" />
          <span class="number">{{ realData.loadpower.value }}</span>
          <div class="txt">
            <span v-if="realData.loadpower.status != ''" class="status"
              :style="{ background: realData.loadpower.status }"></span>
            <span class="desc">{{ realData.loadpower.desc }}（{{ realData.loadpower.unit }}）</span>
          </div>
        </span>
        <!-- 光伏 -->
        <span v-if="realData.solarpower" class="gf">
          <img src="/static/images/svolt/nanwang/chongdianzhuang-bj.png" />
          <span class="number">{{ realData.solarpower.value }}</span>
          <div class="txt">
            <span v-if="realData.solarpower.status != ''" class="status"
              :style="{ background: realData.solarpower.status }"></span>
            <span class="desc">{{ realData.solarpower.desc }}（{{ realData.solarpower.unit }}）</span>
          </div>
        </span>
        <!-- <div class="flow">
          <FlowBall :styles="dir01" :dir="1"></FlowBall>
          <FlowBall :styles="dir02" :dir="2"></FlowBall>
          <FlowBall :styles="dir03" :dir="3"></FlowBall>
        </div> -->
      </span>
    </span>
    <!-- 光储充-->
    <span v-for="(item,index) in centerImgs" :key="index" class="type3-wrap"
      v-if="item.class=='type3' && centerImgId==item.panelId">
      <img :class="item.class" :src="item.src" />
      <span class="threeParts">
        <!-- 储能 -->
        <span v-if="realData.storedenergypower" class="cn">
          <img src="/static/images/svolt/nanwang/chongdianzhuang-bj.png" />
          <span class="number">{{ realData.storedenergypower.value }}</span>
          <div class="txt">
            <span v-if="realData.storedenergypower.status != ''" class="status"
              :style="{ background: realData.storedenergypower.status }"></span>
            <span class="desc">{{ realData.storedenergypower.desc }}（{{ realData.storedenergypower.unit }}）</span>
          </div>
        </span>
        <!-- 电网 -->
        <span v-if="realData.electricsupplypower" class="dw">
          <img src="/static/images/svolt/nanwang/chongdianzhuang-bj.png" />
          <span class="number">{{ realData.electricsupplypower.value }}</span>
          <div class="txt">
            <span v-if="realData.electricsupplypower.status != ''" class="status"
              :style="{ background: realData.electricsupplypower.status }"></span>
            <span class="desc">{{ realData.electricsupplypower.desc }}（{{ realData.electricsupplypower.unit }}）</span>
          </div>
        </span>
        <!-- 负荷 -->
        <span v-if="realData.loadpower" class="fh">
          <img src="/static/images/svolt/nanwang/chongdianzhuang-bj.png" />
          <span class="number">{{ realData.loadpower.value }}</span>
          <div class="txt">
            <span v-if="realData.loadpower.status != ''" class="status"
              :style="{ background: realData.loadpower.status }"></span>
            <span class="desc">{{ realData.loadpower.desc }}（{{ realData.loadpower.unit }}）</span>
          </div>
        </span>
        <!-- 光伏 -->
        <span v-if="realData.solarpower" class="gf">
          <img src="/static/images/svolt/nanwang/chongdianzhuang-bj.png" />
          <span class="number">{{ realData.solarpower.value }}</span>
          <div class="txt">
            <span v-if="realData.solarpower.status != ''" class="status"
              :style="{ background: realData.solarpower.status }"></span>
            <span class="desc">{{ realData.solarpower.desc }}（{{ realData.solarpower.unit }}）</span>
          </div>
        </span>
        <!-- 充电桩 -->
        <span v-if="realData.chargingpilepower" class="cdz">
          <img src="/static/images/svolt/nanwang/chongdianzhuang-bj.png" />
          <span class="number">{{ realData.chargingpilepower.value }}</span>
          <div class="txt">
            <span v-if="realData.chargingpilepower.status != ''" class="status"
              :style="{ background: realData.chargingpilepower.status }"></span>
            <span class="desc">{{ realData.chargingpilepower.desc }}（{{ realData.chargingpilepower.unit }}）</span>
          </div>
        </span>
        <!-- <div class="flow">
          <FlowBall :styles="dir01" :dir="1"></FlowBall>
          <FlowBall :styles="dir02" :dir="2"></FlowBall>
          <FlowBall :styles="dir03" :dir="3"></FlowBall>
        </div> -->
      </span>
    </span>
  </div>
</template>

<script>
  import {
    getInfo
  } from '@/utils/auth';
  import T from '@/utils/tools';
  import FlowBall from './flow-ball';
  import Sun from './sun';
  import {
    centerImages
  } from '@/utils/centerImages';
  export default {
    components: {
      FlowBall,
      Sun
    },
    props: {
      data: {
        type: [Object, Number, String]
      },
      url: {
        type: String,
        default: ''
      },
      centerImgId: '',
      isShowMenu: {
        type: Boolean
      }
    },
    data() {
      return {
        centerImgs: [],
        realData: {},
        projectId: this.$route.query.projectId,
        userInfo: {},
        authority: [], //权限
        // 3个场景-电网
        dir01: {
          width: '100px',
          top: '32.1%',
          left: '38%',
          transform: 'rotate(32deg)',
          background: 'transparent'
        },
        // 3个场景-储能
        dir02: {
          width: '75px',
          top: '41.5%',
          left: '46.5%',
          transform: 'rotate(-32deg)',
          background: 'transparent'
        },
        // 3个场景-负荷
        dir03: {
          width: '75px',
          top: '41.2%',
          left: '68%',
          transform: 'rotate(30deg)',
          background: 'transparent'
        },
        // 4个场景-光伏
        dir04: {
          width: '85px',
          top: '31.7%',
          left: '34.2%',
          transform: 'rotate(31deg)',
          background: 'transparent'
        },
        // 4个场景-储能
        dir05: {
          width: '57px',
          top: '42.4%',
          left: '44.6%',
          transform: 'rotate(-31deg)',
          background: 'transparent'
        },
        // 4个场景-负荷
        dir06: {
          width: '100px',
          top: '42.7%',
          left: '61.8%',
          transform: 'rotate(30deg)',
          background: 'transparent'
        },
        // 4个场景-电网
        dir07: {
          width: '85px',
          top: '34.6%',
          left: '67%',
          transform: 'rotate(-31deg)',
          background: 'transparent'
        },
        dir08: {
          width: '87px',
          top: '40%',
          left: '68%',
          transform: 'rotate(-32deg)',
          background: 'transparent'
        },
        sun01: {
          top: '18%',
          left: '69%',
        },
        sun02: {
          top: '15%',
          left: '5%',
        }
      };
    },
    watch: {
      data: {
        handler(v) {
          this.realData = v
        },
        immediate: true,
        deep: true
      },
      isShowMenu(val) {
        let nwCenter = document.getElementsByClassName('nw-center');
        if (val) {
          if (nwCenter[0] && nwCenter[0].children[0]) {
            nwCenter[0].children[0].style.marginTop = "11%";
            nwCenter[0].children[0].style.marginLeft = "20px";
          }
        } else {
          if (nwCenter[0] && nwCenter[0].children[0]) {
            nwCenter[0].children[0].style.marginTop = "8%";
            nwCenter[0].children[0].style.marginLeft = "0px";
          }
        }
      }
    },
    methods: {
      //初始数据
      init() {
        let tempAuth = localStorage.getItem('ActiveProjectModule');
        if (tempAuth) {
          let json = JSON.parse(tempAuth);
          this.authority = json.resourceIds;
        }
        this.centerImgs = centerImages;
      }
    },
    created(){
    },
    mounted() {
      this.init();
    }
  };
</script>

<style lang="scss" scoped>
  .flow {
    position: absolute;
    top: 0px;
    left: 50%;
    transform: translate(-50%);
    width: 700px;
    height: 1080px;
    border: 0px solid;
  }

  .nw-center {
    position: absolute;
    overflow: hidden;
    overflow-x: hidden;
    width: 100%;
    height: auto;
    z-index: 0;
    top: 0px;
    text-align: center;
    background-color: #d8e8fe;

    /* 3个场景 */
    .type1-wrap {
      .type1 {
        width: 50%;
        margin-top: 100px;
        position: relative;
        z-index: 0;
      }

      .threeParts {
        .cn {
          position: absolute;
          z-index: 1;
          top: 40%;
          left: 47%;
          width: 108px;
          height: 112px;

          .number {
            display: inline-block;
            width: 108px;
            position: absolute;
            top: 15px;
            left: 0;
            font-size: 18px;
            text-align: center;
            font-weight: 700;
            color: #90cfff;
          }

          .txt {
            top: 35px;
            left: 0px;
            display: inline-block;
            width: 108px;
            position: absolute;

            .status {
              width: 12px;
              height: 12px;
              border-radius: 50%;
              display: inline-block;
            }

            .desc {
              font-size: 12px;
              color: #ffffff;
            }
          }
        }

        .dw {
          position: absolute;
          z-index: 1;
          top: 24%;
          left: 56%;
          width: 108px;
          height: 112px;

          .number {
            display: inline-block;
            width: 108px;
            position: absolute;
            top: 15px;
            left: 0;
            font-size: 18px;
            text-align: center;
            font-weight: 700;
            color: #90cfff;
          }

          .txt {
            top: 35px;
            left: 0px;
            display: inline-block;
            width: 108px;
            position: absolute;

            .status {
              width: 12px;
              height: 12px;
              border-radius: 50%;
              display: inline-block;
            }

            .desc {
              font-size: 12px;
              color: #ffffff;
            }
          }
        }

        .fh {
          position: absolute;
          z-index: 1;
          top: 39%;
          left: 57%;
          width: 108px;
          height: 112px;

          .number {
            display: inline-block;
            width: 108px;
            position: absolute;
            top: 15px;
            left: 0;
            font-size: 18px;
            text-align: center;
            font-weight: 700;
            color: #90cfff;
          }

          .txt {
            top: 35px;
            left: 0px;
            display: inline-block;
            width: 108px;
            position: absolute;

            .status {
              width: 12px;
              height: 12px;
              border-radius: 50%;
              display: inline-block;
            }

            .desc {
              font-size: 12px;
              color: #ffffff;
            }
          }
        }
      }

    }

    .type2-wrap {
      .type2 {
        width: 50%;
        margin-top: 100px;
        position: relative;
        z-index: 0;
      }

      .threeParts {
        .cn {
          position: absolute;
          z-index: 1;
          top: 45%;
          left: 43%;
          width: 108px;
          height: 112px;

          .number {
            display: inline-block;
            width: 108px;
            position: absolute;
            top: 15px;
            left: 0;
            font-size: 18px;
            text-align: center;
            font-weight: 700;
            color: #90cfff;
          }

          .txt {
            top: 35px;
            left: 0px;
            display: inline-block;
            width: 108px;
            position: absolute;

            .status {
              width: 12px;
              height: 12px;
              border-radius: 50%;
              display: inline-block;
            }

            .desc {
              font-size: 12px;
              color: #ffffff;
            }
          }
        }

        .dw {
          position: absolute;
          z-index: 1;
          top: 22%;
          left: 64%;
          width: 108px;
          height: 112px;

          .number {
            display: inline-block;
            width: 108px;
            position: absolute;
            top: 15px;
            left: 0;
            font-size: 18px;
            text-align: center;
            font-weight: 700;
            color: #90cfff;
          }

          .txt {
            top: 35px;
            left: 0px;
            display: inline-block;
            width: 108px;
            position: absolute;

            .status {
              width: 12px;
              height: 12px;
              border-radius: 50%;
              display: inline-block;
            }

            .desc {
              font-size: 12px;
              color: #ffffff;
            }
          }
        }

        .fh {
          position: absolute;
          z-index: 1;
          top: 45%;
          left: 57%;
          width: 108px;
          height: 112px;

          .number {
            display: inline-block;
            width: 108px;
            position: absolute;
            top: 15px;
            left: 0;
            font-size: 18px;
            text-align: center;
            font-weight: 700;
            color: #90cfff;
          }

          .txt {
            top: 35px;
            left: 0px;
            display: inline-block;
            width: 108px;
            position: absolute;

            .status {
              width: 12px;
              height: 12px;
              border-radius: 50%;
              display: inline-block;
            }

            .desc {
              font-size: 12px;
              color: #ffffff;
            }
          }
        }

        .gf {
          position: absolute;
          z-index: 1;
          top: 15%;
          left: 36%;
          width: 108px;
          height: 112px;

          .number {
            display: inline-block;
            width: 108px;
            position: absolute;
            top: 15px;
            left: 0;
            font-size: 18px;
            text-align: center;
            font-weight: 700;
            color: #90cfff;
          }

          .txt {
            top: 35px;
            left: 0px;
            display: inline-block;
            width: 108px;
            position: absolute;

            .status {
              width: 12px;
              height: 12px;
              border-radius: 50%;
              display: inline-block;
            }

            .desc {
              font-size: 12px;
              color: #ffffff;
            }
          }
        }

      }

    }

    .type3-wrap {
      .type3 {
        width: 43%;
        margin-top: 100px;
        position: relative;
        z-index: 0;
      }

      .threeParts {
        .cn {
          position: absolute;
          z-index: 1;
          top: 52%;
          left: 42%;
          width: 108px;
          height: 112px;

          .number {
            display: inline-block;
            width: 108px;
            position: absolute;
            top: 15px;
            left: 0;
            font-size: 18px;
            text-align: center;
            font-weight: 700;
            color: #90cfff;
          }

          .txt {
            top: 35px;
            left: 0px;
            display: inline-block;
            width: 108px;
            position: absolute;

            .status {
              width: 12px;
              height: 12px;
              border-radius: 50%;
              display: inline-block;
            }

            .desc {
              font-size: 12px;
              color: #ffffff;
            }
          }
        }

        .dw {
          position: absolute;
          z-index: 1;
          top: 28%;
          left: 62%;
          width: 108px;
          height: 112px;

          .number {
            display: inline-block;
            width: 108px;
            position: absolute;
            top: 15px;
            left: 0;
            font-size: 18px;
            text-align: center;
            font-weight: 700;
            color: #90cfff;
          }

          .txt {
            top: 35px;
            left: 0px;
            display: inline-block;
            width: 108px;
            position: absolute;

            .status {
              width: 12px;
              height: 12px;
              border-radius: 50%;
              display: inline-block;
            }

            .desc {
              font-size: 12px;
              color: #ffffff;
            }
          }
        }

        .fh {
          position: absolute;
          z-index: 1;
          top: 47%;
          left: 57%;
          width: 108px;
          height: 112px;

          .number {
            display: inline-block;
            width: 108px;
            position: absolute;
            top: 15px;
            left: 0;
            font-size: 18px;
            text-align: center;
            font-weight: 700;
            color: #90cfff;
          }

          .txt {
            top: 35px;
            left: 0px;
            display: inline-block;
            width: 108px;
            position: absolute;

            .status {
              width: 12px;
              height: 12px;
              border-radius: 50%;
              display: inline-block;
            }

            .desc {
              font-size: 12px;
              color: #ffffff;
            }
          }
        }

        .gf {
          position: absolute;
          z-index: 1;
          top: 21%;
          left: 37%;
          width: 108px;
          height: 112px;

          .number {
            display: inline-block;
            width: 108px;
            position: absolute;
            top: 15px;
            left: 0;
            font-size: 18px;
            text-align: center;
            font-weight: 700;
            color: #90cfff;
          }

          .txt {
            top: 35px;
            left: 0px;
            display: inline-block;
            width: 108px;
            position: absolute;

            .status {
              width: 12px;
              height: 12px;
              border-radius: 50%;
              display: inline-block;
            }

            .desc {
              font-size: 12px;
              color: #ffffff;
            }
          }
        }

        .cdz {
          position: absolute;
          z-index: 1;
          top: 12%;
          left: 53%;
          width: 108px;
          height: 112px;

          .number {
            display: inline-block;
            width: 108px;
            position: absolute;
            top: 15px;
            left: 0;
            font-size: 18px;
            text-align: center;
            font-weight: 700;
            color: #90cfff;
          }

          .txt {
            top: 35px;
            left: 0px;
            display: inline-block;
            width: 108px;
            position: absolute;

            .status {
              width: 12px;
              height: 12px;
              border-radius: 50%;
              display: inline-block;
            }

            .desc {
              font-size: 12px;
              color: #ffffff;
            }
          }
        }
      }

    }


  }
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/center.vue